export default [
  {
    id: 1,
    html: '<div style="font-weight: 400">' +
      '<div style="font-weight: 500">따뜻하고 깨끗한 물 제공(안전보건규칙 제563조제3항)</div>' +
      '<div>※ 온수기‧보온병 등을 활용해 작업자가 수시로 따뜻한 물을 마실 수 있도록 조치</div>' +
      '</div>',
    is_checked: '',
    note: '',
    title: '따뜻한 물',
    titleColor: '#F9F9F9',
  },
  {
    id: 2,
    html: '<div style="font-weight: 400">' +
      '<div style="font-weight: 500">추위를 피할 수 있는 따뜻한 장소 마련(안전보건규칙 제566조)</div>' +
      '<div>※ 가급적 작업장소와 가까운 곳에 설치</div>' +
      '<div>※ 히터 등 난방장치 설치 시 화재 또는 유해가스 중독 우려가 없도록 설치</div>' +
      '</div>',
    is_checked: '',
    note: '',
    title: '따뜻한 장소',
    titleColor: '#F9F9F9',
  },
  {
    id: 3,
    html: '<div style="font-weight: 400">' +
      '<div style="font-weight: 500">여러 겹의 옷 착용(3겹 이상 권고)</div>' +
      '<div>※ (바깥층) 바람이나 물기를 막고 통기성을 갖춘 재질의 옷</div>' +
      '<div>※ (중간층) 젖을 시에도 보온성이 유지되는 재질의 옷</div>' +
      '<div>※ (안 층) 땀을 제거하기 용이한 재질의 옷</div>' +
      '</div>',
    is_checked: '',
    note: '',
    title: '따뜻한 옷(방한장구)',
    titleColor: '#F9F9F9',
  },
  {
    id: 4,
    html: '<div style="font-weight: 400">' +
      '<div style="font-weight: 500">방한용품 착용</div>' +
      '<div>- 보온·방수기능 신발 및 두꺼운 양말</div>' +
      '<div>- 얼굴과 입을 가리는 마스크</div>' +
      '<div>- 모자 및 보온·방수기능 장갑</div>' +
      '<div>※ 영하 7℃ 이하에서는 맨 손으로 금속 표면을 잡지 말고 반드시 장갑 착용</div>' +
      '<div>※ 물에 젖기 쉬운 작업을 하는 경우 방수 기능이 있는 장갑 착용</div>' +
      '</div>',
    is_checked: '',
    note: '',
    title: '따뜻한 옷(방한장구)',
  },
  {
    id: 5,
    html: '<div style="font-weight: 400">' +
      '<div style="font-weight: 500">한파 특보 시 옥외작업 최소화</div>' +
      '<div>※ 추운 시간대(새벽) 옥외작업시간·휴식시간 조정 등</div>' +
      '</div>',
    is_checked: '',
    note: '',
    title: '기타',
    titleColor: '#F9F9F9',
  },
  {
    id: 6,
    label: '한랭질환 예방가이드를 근로자가 쉽게 볼 수 있는 위치에 게시',
    is_checked: '',
    note: '',
    title: '기타',
  },
  {
    id: 7,
    html: '<div style="font-weight: 400">' +
      '<div style="font-weight: 500">근로자에게 한랭질환 예방교육 실시</div>' +
      '<div>※ 한랭질환의 종류와 예방방법, 증상, 응급조치 요령 등</div>' +
      '</div>',
    is_checked: '',
    note: '',
    title: '기타',
  },
  {
    id: 8,
    html: '<div style="font-weight: 400">' +
      '<div style="font-weight: 500">운동지도 및 민감군 사전관리</div>' +
      '<div>※ (민감군) 고혈압, 당뇨, 갑상선 기능저하, 허약체질, 신규배치 노동자 등</div>' +
      '</div>',
    is_checked: '',
    note: '',
    title: '기타',
  },
  {
    id: 9,
    label: '동료작업자간 상호관찰 및 한랭질환 발생 시 응급처치',
    is_checked: '',
    note: '',
    title: '기타',
  },
];
